/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Cancel_Confirm_TextInputs */



/**
* | output |
* | --- |
* | "This marks the stuck sync as failed so others can sync again." |
*
* @param {Snapshot_History_Cancel_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_cancel_confirm_text = /** @type {((inputs?: Snapshot_History_Cancel_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Cancel_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
	if (locale === "de") return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
	if (locale === "it") return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
	if (locale === "es") return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
	return /** @type {LocalizedString} */ ("This marks the stuck sync as failed so others can sync again.")
});